<template>
	<cm-lightbox v-if="lightboxOwnerVisible" @lgbcancel="onCancel">
		<template v-slot:header>{{ lightbox.header }}</template>

		<template v-slot:body>
			<div class="lightbox__block">
				<div class="lightbox__title">{{ preface.title }}</div>

				<cm-dropdown
					:type="preface.dropdown.type"
					:name="preface.name"
					:items="preface.dropdown.categories"
					:value="preface.dropdown.value"
					:status="preface.dropdown.status"
					:system="preface.dropdown.system"
					@click="onChange($event, 'dropdown')"
				/>
			</div>

			<template v-if="owner">
				<div class="lightbox__block" v-for="(block, index) in lightbox.body" :key="index">
					<div class="lightbox__title">{{ block.title }}</div>

					<cm-input
						:type="'email'"
						:name="block.name"
						:value="block.value"
						:status="block.status"
						:disabled="block.disabled"
						v-if="block.name === 'email'"
						@paste="onChange($event, 'input')"
						@input="onChange($event, 'input')"
						@change="onChange($event, 'input')"
					/>
					<cm-input
						:type="'tel'"
						:name="block.name"
						:value="block.value"
						:mask="'phone'"
						:status="block.status"
						:disabled="block.disabled"
						v-else-if="block.name === 'phone'"
						@focus="onChange($event, 'input')"
						@iptinput="onChange($event, 'input')"
						@paste="onChange($event, 'input')"
						@iptchange="onChange($event, 'input')"
					/>
					<cm-input
						:type="'text'"
						:name="block.name"
						:value="block.value"
						:status="block.status"
						:disabled="block.disabled"
						v-else
						@input="onChange($event, 'input')"
						@paste="onChange($event, 'input')"
						@change="onChange($event, 'input')"
						@blur="onChange($event, 'input')"
					/>

					<span v-if="block.error" class="lightbox__error">{{ block.error }}</span>
				</div>
			</template>
		</template>

		<template v-slot:footer>
			<cm-button
				type="text"
				value="Изменить владельца"
				paint="blue"
				action="changeOwner"
				:disabled="!validation"
				@click="onApply"
			/>
		</template>
	</cm-lightbox>
</template>

<script>
	import { mapGetters, mapMutations, mapActions } from "vuex";

	import Lightbox from "../appearance/Lightbox.vue";
	import Button from "../components/Button.vue";
	import Dropdown from "../components/Dropdown.vue";
	import Input from "../components/Input.vue";

	export default {
		components: {
			"cm-button": Button,
			"cm-dropdown": Dropdown,
			"cm-input": Input,
			"cm-lightbox": Lightbox,
		},
		data() {
			return {
				lightbox: null,
				preface: {
					id: 0,
					kind: "set",
					name: "owner",
					title: "Владелец",
					value: "",
					dropdown: {
						type: "simple",
						name: "",
						value: "",
						status: "default",
						error: "",
						errorMessage: "Неверный формат",
						categories: [
							{
								id: 0,
								name: "exist",
								title: "Существующий пользователь",
							},
							{
								id: 1,
								name: "new",
								title: "Новый пользователь",
							},
						],
					},
				},
				owner: null,
				validation: false,
			};
		},
		computed: {
			...mapGetters({
				lightboxOwnerVisible: "lightboxOwnerVisible",
			}),
			state() {
				return this.$store.state;
			},
		},
		methods: {
			...mapMutations(["showLightboxOwner"]),
			...mapActions(["changeSystemOwner"]),

			/* INIT FUNCTIONS */
			initLightbox() {
				this.lightbox = {
					header: "Изменение владельца системы",
					body: [
						{
							id: 0,
							kind: "single",
							name: "last_name",
							title: "Фамилия",
							value: null,
							status: "default",
							error: false,
							errorMessage: "Неверный формат",
						},
					],
				};
			},
			initLightboxBody() {
				if (this.owner == "exist") {
					this.lightbox.body = [
						{
							kind: "single",
							type: "input",
							name: "email",
							title: "Электронная почта владельца",
							value: "",
							status: "default",
							error: "",
						},
					];
				} else if (this.owner == "new") {
					this.lightbox.body = [
						{
							kind: "single",
							type: "input",
							name: "last_name",
							title: "Фамилия владельца",
							value: "",
							status: "default",
							error: "",
						},
						{
							kind: "single",
							type: "input",
							name: "first_name",
							title: "Имя владельца",
							value: "",
							status: "default",
							error: "",
						},
						{
							kind: "single",
							type: "input",
							name: "middle_name",
							title: "Отчество владельца",
							value: "",
							status: "default",
							error: "",
						},
						{
							kind: "single",
							type: "input",
							name: "phone",
							title: "Телефон владельца",
							value: "",
							status: "default",
							error: "",
						},
						{
							kind: "single",
							type: "input",
							name: "email",
							title: "Электронная почта владельца",
							value: "",
							status: "default",
							error: "",
						},
						{
							kind: "single",
							type: "input",
							name: "password",
							title: "Пароль владельца",
							value: "",
							status: "default",
							error: "",
						},
					];
				}
			},

			/* SPECIAL HANDLERS */
			nandleInput(payload) {
				let input = this.lightbox.body.find((element) => element.name == payload.name);

				if (input) {
					input.value = payload.value;

					if (payload.value.match(this.state.common.patterns[payload.name])) {
						input.status = "valid";
						input.error = null;
					} else {
						input.status = "invalid";
						input.error = this.state.common.errors[payload.name];
					}
				}
			},
			handleDropdown(payload) {
				this.owner = payload.value;
				this.preface.dropdown.value = payload.title;
				this.preface.dropdown.status = "valid";

				this.initLightboxBody();
			},
			checkValidation() {
				if (this.lightbox.body?.length) {
					this.validation = this.lightbox.body.every((element) => {
						if (element.kind == "single") {
							if (element.type == "input") return element.status == "valid";
							if (element.type == "dropdown") return element.dropdown.status == "valid";
						} else if (element.kind == "double") {
							if (element.first.type == "input") return element.first.status == "valid";
							if (element.last.type == "input") return element.last.status == "valid";
						}
					});
				}
			},

			/* EVENT HANDLERS */
			onChange(event, source) {
				let payload = null;

				if (source === "input") {
					payload = {
						name: event.target.name,
						value: event.target.value,
						event: event.type,
					};

					this.nandleInput(payload);
				}

				if (source === "dropdown") {
					if (event.target.closest(".dropdown__item")) {
						payload = {
							name: event.target.closest(".dropdown").getAttribute("name"),
							id: event.target.closest(".dropdown__item").getAttribute("data-id"),
							title: event.target.closest(".dropdown__item").querySelector(".dropdown__title").innerHTML,
							value: event.target.closest(".dropdown__item").getAttribute("data-name"),
						};

						if (payload.name == "owner") this.handleDropdown(payload);
					}
				}

				this.checkValidation();
			},
			onCancel() {
				this.showLightboxOwner(false);
				this.onReset();
			},
			onApply() {
				let payload = {
					owner: this.owner,
				};

				this.lightbox.body.forEach((item) => {
					payload[item.name] = item.value;
				});

				this.changeSystemOwner(payload);
				this.showLightboxOwner(false);
				this.onReset();
			},
			onReset() {
				if (this.lightbox.body?.length) {
					this.lightbox.body.forEach((element) => {
						element.value = null;
						element.status = "default";
						element.error = false;
					});
				}

				this.preface.dropdown.value = "";
				this.preface.dropdown.status = "default";
				this.owner = null;
				this.validation = false;
			},
		},
		created() {
			this.initLightbox();
		},
	};
</script>

<style lang="scss" scoped></style>
